// jquery is being loaded in the head, with defer attribute

// run main once the doc has loaded AND jquery is ready

$(document).ready(function () {
    idsStart();
});

var idsProjectData = null;

async function idsStart() {
    // chceck if the variable idsProductHandle is defined
    if (idsProductHandle == undefined) {
        console.log('productHandle is not defined');
        return;
    }

    // with the product handle, try and fetch the product data
    const projectData = await idsGetprojectData(idsProductHandle);

    // if the product data is not found, log an error and return
    if (!projectData) {
        console.log('projectData not found');
        return;
    }
    else {
        idsProjectData = projectData;
    }

    // try to get the URL of the default media gallery image -> $('media-gallery').find('img').attr('src')
    // if the image is not found, log an error and return
    var defaultImageUrl = $('media-gallery').find('img').attr('src');
    if (!defaultImageUrl) {
        console.log('defaultImage not found');
        return;
    }

    // add and id to the media gallery image -> ids-preview-image
    $('media-gallery').find('img').attr('id', 'ids-preview-image');

    // remove any srcset attribute from the image
    $('#ids-preview-image').removeAttr('srcset');

    // add a div after the div with class 'product__title'

    $('.product__title').after('<div id="ids-customisation"></div>');

    idsSetupCustomisationForm(projectData);
}

async function idsReplaceImage(imageUrl) {
    await new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = resolve;
        image.onerror = reject;
        image.src = imageUrl;
    });
    $('#ids-preview-image').attr('src', imageUrl);
}



function idsSetupCustomisationForm(projectData) {
    projectData.variables.forEach((v) => {
        v.optionType = "variable";
    });

    projectData.artworkOptions.forEach((ao) => {
        ao.optionType = "artworkOption";
    });

    projectData.swatches.forEach((s) => {
        s.optionType = "swatch";
    });

    projectData.graphics.forEach((g) => {
        g.optionType = "graphic";
    });

    var allOptions = projectData.variables
        .concat(projectData.artworkOptions)
        .concat(projectData.swatches)
        .concat(projectData.graphics);

    allOptions.sort(function (a, b) {
        return a.order - b.order;
    });

    allOptions.forEach((o) => {
        switch (o.optionType) {
            case "variable":
                ``;
                loadVariableOption(o);
                break;
            case "swatch":
                // loadSwatchOption(o);
                break;
            case "graphic":
                loadGraphicsOption(o);
                break;
            case "artworkOption":
                // loadArtworkOption(o);
                break;
            default:
                break;
        }
    });

    // for every input, text area, select, checkbox... call generatePreview on change
    $('#ids-customisation').find('input, textarea, select').each(function () {
        $(this).change(function () {
            idsGeneratePreview();
        });
    });

    // on keydown of input, text area
    $('#ids-customisation').find('input, textarea').each(function () {
        $(this).keydown(function () {
            idsInputChanged();
        });
    });
}

function loadVariableOption(variable) {
    if (variable.maxLines != undefined && variable.maxLines > 1) {
        $('#ids-customisation').append(`
      <div class="ids-variable">
        <label for="${idsGetVariableId(variable.name)}">${variable.name}</label>
        <textarea id="${idsGetVariableId(variable.name)}" name="${variable.name}" rows="${variable.maxLines}"></textarea>
      </div>
    `);
        // on change check to make sure user has not entered more than maxLines
        $(`#${idsGetVariableId(variable.name)}`).on("input", function () {
            var maxLines = $(this).attr('rows');
            var lines = $(this).val().split('\n');
            if (lines.length > maxLines) {
                var newText = "";
                for (var i = 0; i < maxLines; i++) {
                    newText += lines[i] + '\n';
                }
                // remove the last \n
                newText = newText.slice(0, -1);
                $(this).val(newText);
            }
        });
    }
    else {
        $('#ids-customisation').append(`
      <div class="ids-variable">
        <label for="${idsGetVariableId(variable.name)}">${variable.name}</label>
        <input type="text" id="${idsGetVariableId(variable.name)}" name="${variable.name}" />
      </div>
    `);
    }
}

function loadGraphicsOption(graphic) {
    // file uploader
    $('#ids-customisation').append(`
      <div class="ids-graphic">
        <label for="${idsGetVariableId(graphic.name)}">${graphic.name}</label>
        <button id="${idsGetVariableId(graphic.name)}" class="ids-graphic-upload">Choose an Image</button>
      </div>
    `);

    $(`#${idsGetVariableId(graphic.name)}`).click(function () {
        userUploadImage(idsGetVariableId(graphic.name));
    });
}

function userUploadImage(id) {
    var fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".jpg,.jpeg,.png";
    fileInput.click();

    fileInput.onchange = function () {
        var file = fileInput.files[0];
        var formData = new FormData();
        formData.append("file", file);
        fetch("https://ais.uyrone.co.uk/UserImageUpload/UploadImage", {
            method: "POST",
            body: formData
        })
            .then(response => response.text())
            .then(data => {
                // Set data property of the button witg tge data

                $(`#${id}`).data('file', data);

                idsGeneratePreview();
            });
    }
}

// gather data entered by user
function idsGetInputData() {
    var data = {
        Variables: [],
        Swatches: [],
        Graphics: [],
        pageCount: idsProjectData.pageCount,
        layersToShow: [],
    };

    idsProjectData.variables.forEach((v) => {
        var id = v.name.replace(/[ {}()&]/g, "-");
        var remove = [];
        if (v.remove == undefined || v.remove == "") {
            remove = [];
        } else {
            remove = v.remove.split(",");
        }
        var removeText = [];
        if (v.removeText == undefined || v.removeText == "") {
            removeText = [];
        } else {
            removeText = v.removeText.split(",");
        }

        var showText = [];
        if (v.showText == undefined || v.showText == "") {
            showText = [];
        } else {
            showText = v.showText.split(",");
        }

        // prefix and suffix

        var prefix;
        if (v.prefix === undefined) {
            prefix = "";
        } else {
            prefix = v.prefix;
        }

        var suffix;
        if (v.suffix === undefined) {
            suffix = "";
        } else {
            suffix = v.suffix;
        }

        var resize;
        if (v.resize === undefined) {
            resize = true;
        } else {
            resize = v.resize;
        }

        var minFontSize;
        if (v.minFontSize === undefined) {
            minFontSize = 12;
        } else {
            minFontSize = v.minFontSize;
        }


        var value = $(`#${id}`).val().replace(/\\n/g, '\n');

        // try to see if id-text exists
        if ($(`#${id}-text`).length > 0) {
            value = $(`#${id}-text`).val().replace(/\\n/g, '\n');

            if (value === undefined || value === "" || value === null) {
                value = $(`#${id}`).val().replace(/\\n/g, '\n');
            }
        }

        // check if hidden (disabled) and set value to empty string
        if ($(`#${id}`).parent().parent().hasClass("hidden")) {
            value = "";
        }

        if (value === undefined) {
            value = "";
        }

        data.Variables.push({
            Name: `{{${v.name}}}`,
            Value: value,
            Remove: remove,
            RemoveText: removeText,
            ShowText: showText,
            Prefix: prefix,
            Suffix: suffix,
            Resize: resize,
            MinFontSize: minFontSize,
        });
    });

    idsProjectData.swatches.forEach((s) => {
        var id = idsGetVariableId(s.name);
        var swatch;
        s.options.forEach((o) => {
            if ($(`#${id}`).val() === o.name) {
                swatch = o;
            }
        });
        data.Swatches.push({
            Name: s.name,
            C: swatch.c,
            M: swatch.m,
            Y: swatch.y,
            K: swatch.k,
        });
    });

    idsProjectData.graphics.forEach((g) => {
        var id = idsGetVariableId(g.name);
        var value;

        value = $(`#${id}`).data('file');


        if (value === undefined || value === "" || value === null) {
            value = "";
        }

        // check if hidden (disabled) and set value to empty string
        if ($(`#${id}`).parent().parent().hasClass("hidden")) {
            value = "";
        }

        var remove = false;
        if (g.option === "Toggle") {
            remove = !$(`#${id}`).prop('checked');

            value = "";
        }

        data.Graphics.push({
            itemLinkName: g.itemLinkName,
            Location: value.replace(/\\/g, "/"),
            fitOption: g.fitOption,
            Remove: remove,
        });
    });

    return data;
}


var idsGenerateData = null;

function idsGeneratePreview() {
    var data = idsGetInputData();

    if (data == idsGenerateData) {
        // don't regenerate the preview if the data is the same
        return;
    }

    idsGenerateData = data;

    var previewId = generateGuid();

    fetch(
        `https://ais.uyrone.co.uk/RenderPreview?product=${encodeURIComponent(idsTemplateId)}&document=${encodeURIComponent(idsProjectData.fileName)}&sessionID=${previewId}&scriptFile=label-preview-v1.jsx`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: '"' + JSON.stringify(data).replace(/"/g, '\\"').replace(/\\n/g, '\\\\n') + '"',
        }
    ).then(res => {

        // Check if status is 2xx
        if (!res.ok) {
            console.error('Failed to generate preview');
            return;
        }

        timeOfLastPreview = Date.now();

        // return contains a list of image urls
        res.json().then((images) => {
            // try to get the first image
            if (images.length > 0) {
                // replace the image with the first image
                idsReplaceImage(images[0]);
            }
        });
    });
}


async function idsGeneratePrint() {
    var data = idsGetInputData();
    var renderId = generateGuid();

    var res = await fetch(
        `https://ais.uyrone.co.uk/RenderPrintReady?product=${encodeURIComponent(idsTemplateId)}&document=${encodeURIComponent(idsProjectData.fileName)}&sessionID=${renderId}`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: '"' + JSON.stringify(data).replace(/"/g, '\\"').replace(/\\n/g, '\\\\n') + '"',
        }
    );

    if (!res.ok) {
        console.log(res);
        console.error('Failed to generate print ready');
        return null;
    }

    return renderId;

}

var idsTimer = null;

function idsInputChanged() {
    // start a timer -> 1s -> idsGeneratePreview
    // if the timer is already running, clear it and start again

    if (idsTimer) {
        clearTimeout(idsTimer);
    }

    idsTimer = setTimeout(() => {
        idsGeneratePreview();
    }, 1000);
}

var idsTemplateId = null;

async function idsGetprojectData(productHandle) {
    // Make a call to https://ais.uyr.one:7268/ProjectFile/ProjectLookup?productId=productHandle

    // This returns a string -> the template id

    // Make a call to https://ais.uyr.one:7268/ProjectFile?projectName=templateId
    // This returns a json string

    // product handle is in two forms '123' or 'abc-def-123'

    // try to get 123 (it may be on its own or it may have a prefix (but it is always after the last dash)
    // we need it as an integer

    var lookupId = productHandle.split('-').pop();

    // make it an integer
    lookupId = parseInt(lookupId);


    // var templateIdResponse = await fetch(`https://ais.uyr.one:7268/ProjectFile/ProjectLookup?productId=${productHandle}`);
    var templateIdResponse = await fetch(`https://uyrone-gelato-delivery.azurewebsites.net/ProductLookup?productCode=${lookupId}`);
    if (!templateIdResponse.ok) {
        console.error('Failed to get template id');
        return null;
    }

    var templateId = await templateIdResponse.text();
    idsTemplateId = templateId;

    var projectDataResponse = await fetch(`https://ais.uyrone.co.uk/ProjectFile?projectName=${templateId}`);

    if (!projectDataResponse.ok) {
        console.error('Failed to get project data');
        return null;
    }

    var projectData = await projectDataResponse.text();

    return JSON.parse(projectData);
}


// function to generate guid
function generateGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

function idsGetVariableId(variableName) {
    return variableName.replace(/[ {}()&]/g, "-");
}